import React, { useState } from 'react'
import { PropTypes } from 'prop-types'
import { Disclosure, Form, UIManager, Input, Level, ThemeProvider, Toaster, Toasts } from '@deseretbook/react-ui'
import { DeseretBook } from '../../dbcom/api'
import { Logger, formatErrorMessage } from '../../dbcom'

const logger = new Logger({ context: 'ApplyGiftCardForm' })

UIManager.injectGlobal()

/**
 * Form to apply gift card to user's subscription.
 *
 * @param {object} [user] current user info
 * @param {object} [subscription] user's subscription info
 * @returns {function} Component
 */
function ApplyGiftCardForm({ user, subscription }) {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [form, setForm] = useState({})

  /**
   * onChange handler for form input.
   */
  function onFormChange({ target }) {
    const { name, value } = target

    setForm({ ...form, [name]: value })
  }

  /**
   * Refreshes page in order to display next_billing_period_amount's updated price.
   */
  function refreshPage() {
    window.location.reload(true)
  }

  /**
   * Updates subscription with applied gift card.
   */
  async function updateSubscription() {
    setIsSubmitting(true)

    try {
      await DeseretBook
        .user(user)
        .subscription(subscription)
        .update(form)

      refreshPage()
      Toasts.success('Successfully applied gift card')
    } catch ({ errors, message }) {
      setIsSubmitting(false)
      Toasts.error('Unable to apply gift card', formatErrorMessage(message, errors))
      logger.warning(`Unable to apply gift card: "${formatErrorMessage(message, errors)}"`, {
        errors,
        user,
        subscription,
        form,
      })
    }
  }

  return (
    <ThemeProvider>
      <Disclosure>
        <Toaster />
        <Disclosure.Header>
          Apply gift card
        </Disclosure.Header>
        <Disclosure.Content>
          <Form onSubmit={updateSubscription} isSubmitting={isSubmitting}>
            <Input
              name="giftCardNumber"
              type="text"
              label="Gift Card Number"
              value={form.giftCardNumber}
              onChange={onFormChange}
              required
            />
            <Level>
              <Level.Right>
                <Form.SubmitButton
                  isPrimary
                >
                  Apply
                </Form.SubmitButton>
              </Level.Right>
            </Level>
          </Form>
        </Disclosure.Content>
      </Disclosure>
    </ThemeProvider>
  )
}

ApplyGiftCardForm.defaultProps = {
  user: {},
  subscription: {},
}

ApplyGiftCardForm.propTypes = {
  user: PropTypes.shape({ id: PropTypes.number }),
  subscription: PropTypes.shape({
    id: PropTypes.number,
    btSubscriptionId: PropTypes.string,
  }),
}

export default ApplyGiftCardForm
